<style>
  .my-pagination /deep/ .ngx-pagination {
    text-align: center;
  }
</style>
<div class="container">
  <div class="row">
    <div class="col-9">
      <nav aria-label="breadcrumb" class="breadCust">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/corporate/home">Home</a></li>
          <li class="breadcrumb-item">
            <a routerLink="/corporate/bu-entities">BU Entities List</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">
            {{header}} Entity for {{buselected}}
          </li>
        </ol>
      </nav>
    </div>
    <div class="col-3">
      <div  style="justify-content: right">
        <input
          type="button"
          value="{{buselected}}"
          *ngIf="isWrite"
          class="custbtn red-lt-icon"
          routerLink="/corporate/selectbu-segmentation"
        />

      </div>
    </div>

  </div>

</div>

<div class="container" >
  <form class="form-horizontal mt-1" [formGroup]="entForm">
    <div class="row">
      <div class="col-md-10 col-xl-7">

        <div class="card mt-1">

          <div class="card-body">

            <div>
              <label for="entForm">Entity Name <span style="color:red">*</span></label>
              <input type="text" appSpace maxlength="80" formControlName="entname" class="form-control form-control-md"
                     placeholder="Provide Entity Name" [ngClass]="{ 'is-invalid': submitted && f.entname.errors }" required>
              <div *ngIf="submitted && f.entname.errors" class="invalid-feedback">
                <div *ngIf="f.entname.errors.required">Entity Name is required</div>
              </div>
            </div>

            <div>
              <label for="entForm">Entity Description</label>
              <textarea appSpace formControlName="entdesc" maxlength="255" class="form-control form-control-md"></textarea>
            </div>

          </div>

          <div class="card-footer text-center mt-1" *ngIf="status">
            <div class="my_class text-center" *ngIf="isWrite" [ngClass]="status ? 'displayblock' : 'displaynone'">
              <button type="submit" class="custbtn"  (click)="addNewBUEntity()" >Submit</button>
            </div>
          </div>
          <div class="card-footer text-center mt-1" *ngIf="!status">
            <div class="my_class text-center" *ngIf="isEdit" [ngClass]="status ? 'displaynone' : 'displayblock'">
              <button type="submit" class="custbtn"  (click)="updateBUEntity()" >Update</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
